/**
 * Toestemmingsteksten die een klant ziet voordat ze iets aanzet. De `version` gaat mee in het
 * verzoek, zodat de server kan bewaren wélke tekst ze zag (AVG: aantoonbare toestemming).
 * Tekst wijzigen = nieuwe versie; de oude versie blijft in het logboek van de server staan.
 */
export const newsletterConsent = {
  // 2026-10b: het meten van openen en klikken en de winkelmandherinnering staan er nu bij.
  version: 'nieuwsbrief-2026-10b',
  text: 'Je krijgt eerst een mail om je aanmelding te bevestigen. Ik zie of je de nieuwsbrief opent en waarop je klikt, en stuur je één keer een seintje als je iets in je mand laat staan. Afmelden kan onderaan elke mail.',
} as const
